import React, { useState, useMemo, useEffect } from "react";
import { Select, MenuItem, Box } from "@mui/material";
import Checkbox from '@mui/material/Checkbox';
import { styled } from '@mui/material/styles';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import InsightTable from "Samarth Module/components/table/insightTable";
import LineGraphOEE from "Samarth Module/components/graph/lineGraphOEE";
import styles from "./multiSelect.module.css";

const OEETrendDropdown = ({ code,data }) => {
    const [selectedOption, setSelectedOption] = useState(["All"]);
    const [tableData, setTableData] = useState([]);
    const [allOEEDetails, setAllOEEDetails] = useState(data);
    const [viewType, setViewType] = useState('graph');
    const [lineName, setLineName] = useState(['All']);
    const uniqueLine = useMemo(() => {
        const lines = data?.map(item => item.name);
        return Array.from(new Set(lines)).filter(Boolean);
    }, [data]);
    const handleChange = (event) => {
        const {
        target: { value },
        } = event;
        if(value!=="All")
        {
            if(!lineName.includes(value) && !lineName.includes('All')) /*when selecting values and All is already not selected*/ 
                setLineName([...lineName,...value.split(',')])
            else if(!lineName.includes(value) && lineName.includes('All')) /*when selecting values and All is already selected*/
                setLineName([...lineName.slice(1),...value.split(',')])
            else /*when unselecting the value which is already selected*/
            {
                let lines=lineName.filter((item)=>{
                    return item!==value
                })
                if(lines.length===0) /*after unselection if the list gets empty we assign to All value*/
                    setLineName(["All"])
                else
                    setLineName(lines)
            }
        }
        else
        {
            setLineName(["All"])
            setSelectedOption(["All"])
        }
        
    };
    const handleToggleBtnChange = (event, newViewType) => {
        if (newViewType !== null) {
            setViewType(newViewType);
        }
    };
    const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
    '& .MuiToggleButtonGroup-grouped': {
      fontSize: "12px",
      fontWeight: 400,
      padding: "5px 5px",
      textTransform: "none",
      width: "9rem",
      color: "#2B2B2B",
      '&:hover': {
        background: "transparent",
      }
    },
    '& .MuiToggleButtonGroup-grouped.Mui-selected': {
      background: "#1F36C7",
      color: "white",
      '&:hover': {
        background: "#1F36C7",
        color: "white"
      }
    }
    }));
    useEffect(()=>{
        let changedData=[]
        if(selectedOption[0] === "All")
        {
            changedData=data
        }
        else
        {
            for(let option of selectedOption)
            {
                const selectedData=data.filter((item) => item.name === option).map((item) =>{
                    return item;
                });
                changedData.push(selectedData[0])
            }
        }
        setAllOEEDetails(changedData)
    },[selectedOption])
    useEffect(()=>{
        setSelectedOption(lineName)
    },[lineName])
    useEffect(()=>{
        setAllOEEDetails(data)
    },[data])
    useEffect(()=>{
        if(viewType === 'table')
        {
            let tableViewData = []
            let tableViewItem = {}
            allOEEDetails.map((item)=>{
                tableViewItem={Line: item.name,CBU: code}
                for (let key in item.data) {
                    tableViewItem = {...tableViewItem,  
                        "L3M Top 25% OEE": item['L3M Top 25% OEE'],
                        "Capacity Master OEE%":item["Capacity_master_OEE%"] * 100, [`Wk ${key?.split(" ").pop()}`]:item.data[key],
                    };
                }
                tableViewData.push(tableViewItem)
            })
            setTableData(tableViewData)
        }
    },[viewType,allOEEDetails])
    return (
        <Box>
            <div style={{display:"flex",flexDirection:"row-reverse"}}>
                <div style={{marginTop:"21px"}}>
                    <StyledToggleButtonGroup
                        color="primary"
                        value={viewType}
                        exclusive
                        onChange={handleToggleBtnChange}
                        aria-label="Platform"
                        size="small"
                    >
                        <ToggleButton value="graph">
                            OEE graph
                        </ToggleButton>
                        <ToggleButton value="table">
                            OEE table
                        </ToggleButton>
                    </StyledToggleButtonGroup>
                </div>
                <div style={{display:"flex",flexDirection:"column"}}>
                    <div className={styles.dropdownContainer}>
                        <span className={styles.listItemHeader}>Lines</span>
                    </div>
                    <div className={styles.menuItemWithCheckbox}>
                        <Select
                            value={lineName}
                            onChange={handleChange}
                            size="small"
                            className={styles.selectedOption}
                            renderValue={(selected) => selected.length === 0 ? 'All' : selected.join(', ')}
                        >
                            <MenuItem className={styles.listItemWithCheckbox} value="All">
                                <Checkbox checked={lineName.includes("All") ? true : false} />
                                Select All
                            </MenuItem>
                            {uniqueLine.map((line) => (
                                <MenuItem className={styles.listItemWithCheckbox} key={line} value={line}>
                                    <Checkbox checked={lineName.indexOf(line) > -1 ? true : false} />
                                    {line}
                                </MenuItem>
                            ))}
                        </Select>
                    </div>
                </div>
            </div>
            {viewType === "graph" ? <LineGraphOEE data={allOEEDetails} /> : <InsightTable type="OEE Trend" data={tableData} />}
        </Box>
    );
};
export default OEETrendDropdown;